import OrderPage from 'components/gruenland/organisms/account/sections/orders/order-page/OrderPage';
import { ShippingMethod } from 'types/entity/cart';
import { Order } from 'types/entity/order';

type Props = {
  order: Order;
  shippingMethods: ShippingMethod[];
};

const PublicOrderPage: React.FC<Props> = ({ order, shippingMethods }) => {
  return <OrderPage order={order} shippingMethods={shippingMethods} />;
};

export default PublicOrderPage;
